import AppBgImage from "../../assets/images/daam_bg_image.png";

export const STORAGE_KEYS = {
  TOKEN: "daam-token",
  SHOW_LOADING: "show_loading",
  ROLE: "role",
};

export const MAIN_FONT_FAMILY = "IBM Plex Sans Arabic";

export const APP_BG_IMAGE = AppBgImage;

export const ENCRYPTION_SECRET_KEY =
  "mFYHMm1T2cNwJhKu1eVs9qkb9zQqnbeUybzOSYX3Nng=";
